import { Epic, ActionsObservable } from 'redux-observable';
import { firebaseStore } from '../firebase';

import { LOAD_SCHOOL, SchoolAction, schoolLoadSuccess, schoolLoadFailure } from '../actions/SchoolActions';
import { StoreState } from '../types';
import { mergeMap, catchError, map, startWith, filter } from 'rxjs/operators';
import { from } from 'rxjs';

const schoolDoc = (schoolId: string) => firebaseStore.collection('search').doc(schoolId);
const spotDocs = (schoolId: string) => schoolDoc(schoolId).collection('spots');

const loadschool = async (schoolId: string) => {
    const schoolSnapshot = await schoolDoc(schoolId).get();

    if (schoolSnapshot.exists) {
        const spotsSnapshot = await spotDocs(schoolId).get();
        return schoolLoadSuccess(schoolSnapshot, spotsSnapshot);
    }

    return schoolLoadFailure(new Error(`School '${schoolId}' does not exist`));
};

const schoolLoadEpic: Epic<SchoolAction, SchoolAction, StoreState> = (action$, store) =>
    action$.ofType(LOAD_SCHOOL)
        .pipe(
            map(a => a.value),
            startWith(store.value.school.loadSchoolId),
            filter(schoolId => !!schoolId),
            mergeMap(schoolId =>
                from(loadschool(schoolId as string))
                .pipe(
                    catchError(error => ActionsObservable.of(schoolLoadFailure(error)))
                )
            )
        );
    
export default schoolLoadEpic;